import { apiCall } from './gqlClient';

const CHALLENGES_QUERY = `
  query challenges($providerId: Float) {
    challenges(providerId: $providerId)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const challengesApiCall = async ({providerId}, fragments = null) => apiCall({ query: CHALLENGES_QUERY, variables: {providerId}, fragments });

const CHALLENGE_QUERY = `
  query challenge($id: String!) {
    challenge(id: $id)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const challengeApiCall = async ({id}, fragments = null) => apiCall({ query: CHALLENGE_QUERY, variables: {id}, fragments });

const CHALLENGEPARTICIPANTS_QUERY = `
  query challengeParticipants($challengeId: String!) {
    challengeParticipants(challengeId: $challengeId)
    {
      id
			athleteProfileId
			challengeId
			status
			optInDate
			startDate
			originalStartDate
			setupAnswers
			currentStreak
			highestStreak
			totalCompletedDays
			missedDays
			consecutiveMisses
			totalScore
			lastLogDate
			previousChallengeId
			previousCompletedDays
			completedAt
			createdAt
			updatedAt
			providerId
			challengeName
			challengeRules
      ...fragments
    }
  }`;

export const challengeParticipantsApiCall = async ({challengeId}, fragments = null) => apiCall({ query: CHALLENGEPARTICIPANTS_QUERY, variables: {challengeId}, fragments });

const CHALLENGELEADERBOARD_QUERY = `
  query challengeLeaderboard($challengeId: String!) {
    challengeLeaderboard(challengeId: $challengeId)
    {
      athleteChallengeId
			athleteProfileId
			currentStreak
			highestStreak
			totalCompletedDays
			totalScore
      ...fragments
    }
  }`;

export const challengeLeaderboardApiCall = async ({challengeId}, fragments = null) => apiCall({ query: CHALLENGELEADERBOARD_QUERY, variables: {challengeId}, fragments });

const MYCHALLENGES_QUERY = `
  query myChallenges {
    myChallenges
    {
      id
			athleteProfileId
			challengeId
			status
			optInDate
			startDate
			originalStartDate
			setupAnswers
			currentStreak
			highestStreak
			totalCompletedDays
			missedDays
			consecutiveMisses
			totalScore
			lastLogDate
			previousChallengeId
			previousCompletedDays
			completedAt
			createdAt
			updatedAt
			providerId
			challengeName
			challengeRules
      ...fragments
    }
  }`;

export const myChallengesApiCall = async (fragments = null) => apiCall({ query: MYCHALLENGES_QUERY, variables: {}, fragments });

const AVAILABLECHALLENGES_QUERY = `
  query availableChallenges($providerId: Float) {
    availableChallenges(providerId: $providerId)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const availableChallengesApiCall = async ({providerId}, fragments = null) => apiCall({ query: AVAILABLECHALLENGES_QUERY, variables: {providerId}, fragments });

const MYCHALLENGEDAILYLOG_QUERY = `
  query myChallengeDailyLog($athleteChallengeId: String!, $logDate: String!) {
    myChallengeDailyLog(athleteChallengeId: $athleteChallengeId, logDate: $logDate)
    {
      id
			athleteChallengeId
			logDate
			ruleLogs
			notes
			missed
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const myChallengeDailyLogApiCall = async ({athleteChallengeId, logDate}, fragments = null) => apiCall({ query: MYCHALLENGEDAILYLOG_QUERY, variables: {athleteChallengeId, logDate}, fragments });

const MYTODAYCHALLENGERULES_QUERY = `
  query myTodayChallengeRules($athleteChallengeId: String!, $logDate: String!) {
    myTodayChallengeRules(athleteChallengeId: $athleteChallengeId, logDate: $logDate)
    {
      rules
			pending
			selectionMode
      ...fragments
    }
  }`;

export const myTodayChallengeRulesApiCall = async ({athleteChallengeId, logDate}, fragments = null) => apiCall({ query: MYTODAYCHALLENGERULES_QUERY, variables: {athleteChallengeId, logDate}, fragments });

const CREATECHALLENGE_QUERY = `
  mutation createChallenge($input: ChallengeInput!) {
    createChallenge(input: $input)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const createChallengeApiCall = async ({input}, fragments = null) => apiCall({ query: CREATECHALLENGE_QUERY, variables: {input}, fragments });

const UPDATECHALLENGE_QUERY = `
  mutation updateChallenge($id: String!, $input: ChallengeInput!) {
    updateChallenge(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const updateChallengeApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATECHALLENGE_QUERY, variables: {id, input}, fragments });

const ACTIVATECHALLENGE_QUERY = `
  mutation activateChallenge($id: String!) {
    activateChallenge(id: $id)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const activateChallengeApiCall = async ({id}, fragments = null) => apiCall({ query: ACTIVATECHALLENGE_QUERY, variables: {id}, fragments });

const CLOSECHALLENGE_QUERY = `
  mutation closeChallenge($id: String!) {
    closeChallenge(id: $id)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const closeChallengeApiCall = async ({id}, fragments = null) => apiCall({ query: CLOSECHALLENGE_QUERY, variables: {id}, fragments });

const ARCHIVECHALLENGE_QUERY = `
  mutation archiveChallenge($id: String!) {
    archiveChallenge(id: $id)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const archiveChallengeApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVECHALLENGE_QUERY, variables: {id}, fragments });

const DUPLICATECHALLENGE_QUERY = `
  mutation duplicateChallenge($id: String!) {
    duplicateChallenge(id: $id)
    {
      id
			providerId
			name
			description
			durationDays
			minStartDate
			lastStartDate
			status
			rules
			completionPolicy
			eliminationPolicy
			rankingConfig
			selectionPolicy
			exclusivityScope
			fallbackChallengeId
			variantGroup
			tutorialSteps
			allowGalleryUploadForToday
			public
			archive
			linkedWorkoutPlanId
			linkedNutritionPlanId
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const duplicateChallengeApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATECHALLENGE_QUERY, variables: {id}, fragments });

const SETPARTICIPANTSTATUS_QUERY = `
  mutation setParticipantStatus($athleteChallengeId: String!, $status: AthleteChallengeStatus!) {
    setParticipantStatus(athleteChallengeId: $athleteChallengeId, status: $status)
    {
      id
			athleteProfileId
			challengeId
			status
			optInDate
			startDate
			originalStartDate
			setupAnswers
			currentStreak
			highestStreak
			totalCompletedDays
			missedDays
			consecutiveMisses
			totalScore
			lastLogDate
			previousChallengeId
			previousCompletedDays
			completedAt
			createdAt
			updatedAt
			providerId
			challengeName
			challengeRules
      ...fragments
    }
  }`;

export const setParticipantStatusApiCall = async ({athleteChallengeId, status}, fragments = null) => apiCall({ query: SETPARTICIPANTSTATUS_QUERY, variables: {athleteChallengeId, status}, fragments });

const ERASEPARTICIPANT_QUERY = `
  mutation eraseParticipant($athleteChallengeId: String!) {
    eraseParticipant(athleteChallengeId: $athleteChallengeId)
  }`;

export const eraseParticipantApiCall = async ({athleteChallengeId}, ) => apiCall({ query: ERASEPARTICIPANT_QUERY, variables: {athleteChallengeId}});

const OPTINTOCHALLENGE_QUERY = `
  mutation optIntoChallenge($challengeId: String!, $startDate: String!, $setupAnswers: JSON) {
    optIntoChallenge(challengeId: $challengeId, startDate: $startDate, setupAnswers: $setupAnswers)
    {
      id
			athleteProfileId
			challengeId
			status
			optInDate
			startDate
			originalStartDate
			setupAnswers
			currentStreak
			highestStreak
			totalCompletedDays
			missedDays
			consecutiveMisses
			totalScore
			lastLogDate
			previousChallengeId
			previousCompletedDays
			completedAt
			createdAt
			updatedAt
			providerId
			challengeName
			challengeRules
      ...fragments
    }
  }`;

export const optIntoChallengeApiCall = async ({challengeId, startDate, setupAnswers}, fragments = null) => apiCall({ query: OPTINTOCHALLENGE_QUERY, variables: {challengeId, startDate, setupAnswers}, fragments });

const DRAWMYDAILYRULES_QUERY = `
  mutation drawMyDailyRules($athleteChallengeId: String!, $logDate: String!) {
    drawMyDailyRules(athleteChallengeId: $athleteChallengeId, logDate: $logDate)
    {
      rules
			pending
			selectionMode
      ...fragments
    }
  }`;

export const drawMyDailyRulesApiCall = async ({athleteChallengeId, logDate}, fragments = null) => apiCall({ query: DRAWMYDAILYRULES_QUERY, variables: {athleteChallengeId, logDate}, fragments });

const UPSERTMYCHALLENGEDAILYLOG_QUERY = `
  mutation upsertMyChallengeDailyLog($athleteChallengeId: String!, $logDate: String!, $ruleLogs: JSON!, $notes: JSON) {
    upsertMyChallengeDailyLog(athleteChallengeId: $athleteChallengeId, logDate: $logDate, ruleLogs: $ruleLogs, notes: $notes)
    {
      id
			athleteChallengeId
			logDate
			ruleLogs
			notes
			missed
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const upsertMyChallengeDailyLogApiCall = async ({athleteChallengeId, logDate, ruleLogs, notes}, fragments = null) => apiCall({ query: UPSERTMYCHALLENGEDAILYLOG_QUERY, variables: {athleteChallengeId, logDate, ruleLogs, notes}, fragments });
